module.exports = "<ul class=\"error-messages\" *ngIf=\"errorList\">\r\n  <li *ngFor=\"let error of errorList\">\r\n    {{ error }}\r\n  </li>\r\n</ul>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/shared/list-errors.component.html
// module id = ../../../../../src/app/shared/list-errors.component.html
// module chunks = main